import { useEffect, useState } from "react";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { Circle } from "@phosphor-icons/react";

dayjs.extend(relativeTime);

// Oct 2026, user's explicit ask ("last updated at pill... make sure it's
// updated, stale can cause major issue") - a visible, always-on freshness
// indicator for Open Qty data now that the page load itself no longer
// does a live SAP refresh (see server.py's _load_open_pos_for_vendor) -
// freshness depends entirely on the background sync loop + SAP webhook
// staying healthy, so staff/suppliers need to be able to SEE that at a
// glance instead of just trusting it silently. Re-renders its own "Xm
// ago" text every 30s so it doesn't go stale-looking while the page sits
// open, even if the underlying data itself hasn't been re-fetched.
export const FreshnessPill = ({ lastSyncedAt, isFresh, testId }) => {
  const [, forceTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => forceTick((n) => n + 1), 30000);
    return () => clearInterval(id);
  }, []);

  if (!lastSyncedAt) return null;
  const label = isFresh ? dayjs(lastSyncedAt).fromNow() : `${dayjs(lastSyncedAt).fromNow()} - stale`;

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-1 rounded-sm text-[11px] font-sans ${
        isFresh ? "bg-[#F0FDF4] text-[#166534] border border-[#BBF7D0]" : "bg-[#FEF3C7] text-[#92400E] border border-[#FDE68A]"
      }`}
      title={isFresh ? "Open Qty is kept current automatically" : "Background sync hasn't updated recently - Open Qty may not reflect the latest SAP changes"}
      data-testid={testId}
    >
      <Circle size={6} weight="fill" className={isFresh ? "text-[#22C55E]" : "text-[#F59E0B]"} />
      Updated {label}
    </span>
  );
};
